export default __webpack_public_path__ + "static/media/frame_en_sp.7af35204.png";